import styled from '../styled';

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default FormContent;
